<template>
  <v-container fluid class="investjournal-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn to="/investjournal/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindJournal=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              item-key="_id"
              v-model="data_selected"
              loading-text="Loading... Please wait"
              class="investjournals-table"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="data_journals"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteJournal"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Journal?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_journal.journalnum }} 
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteJournal = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_journal)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line">
                    <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                    </v-avatar>
                  </p>
                  <p class="two-line">
                    <span style="margin-left:5px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                  </p>
                </div>
              </template>
              <template v-slot:item.journalnum="{ item }">
                <p class="two-line">{{ item.journaltype  }}</p>
                <p class="two-line">{{ item.journalnum  }}</p>
                <p v-if="item.journaldate!=null" class="two-line">{{ new Date(item.journaldate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.journalstartdate="{ item }">
                <p v-if="item.journalstartdate!=null" class="two-line">{{ new Date(item.journalstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}&nbsp;-</p>
                <p v-if="item.journalenddate!=null" class="two-line">{{ new Date(item.journalenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.fundid="{ item }">
                <p class="two-line">{{ funds.length>0 && funds.find(i=>i._id == item.fundid)!=null ? funds.find(i=>i._id == item.fundid)['fundname'] : '' }}</p>
              </template>
              <template v-slot:item.journaltotal="{ item }">
                {{ item.journaltotal.toFixed(2).toLocaleString('en-SG') }}
              </template>
              <template v-slot:item.journalstatus="{ item }">
                <v-chip
                  v-if="item.journalstatus!=undefined"
                  :color="getStatusColor(item.journalstatus)"
                  small
                >
                  {{ item.journalstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.journalstatus=='New'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindJournal"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Journals</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="funds.filter(x=>x.fundstatus=='Active').map(x => {
                              return {text: x.fundname, value: x._id};
                            })"
                    v-model="find_query.fundid"
                    label="InvestFund"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :items="['New', 'Pending', 'Partial', 'Completed', 'Audit', 'Void']"
                    v-model="find_query.journalstatus"
                    label="InvestJournal Status"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="InvestJournal Num"
                    v-model="find_query.journalnum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="InvestJournal Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_startdate"
                            v-model="menu_startdate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.startdate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.startdate"
                                label="Start Date"
                                v-bind="attrs"
                                v-bind:value="find_query.startdate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter start date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.startdate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_startdate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_startdate.save(find_query.startdate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_enddate"
                            v-model="menu_enddate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.enddate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.enddate"
                                label="End Date"
                                v-bind="attrs"
                                v-bind:value="find_query.enddate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter end date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.enddate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_enddate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_enddate.save(find_query.enddate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindJournal = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetInvestJournals"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findInvestJournals"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '@/util/tools';

export default {
  name: 'InvestJournalList',
  data() {
    return {
      config,
      snackbar: null,
      isDeleteJournal: false,
      dialogAlert: false,
      dialogMessage: '',
      isFindJournal: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      delete_journal: {},
      find_query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Journal', value: 'journalnum', sortable: false, width: '15%' },
        { text: 'Period', value: 'journalstartdate', sortable: false, width: '10%' },
        { text: 'Fund', value: 'fundid' },
        { text: 'Amount', value: 'journaltotal', width: '15%' },
        { text: 'Created', value: 'userid', width: '10%' },
        { text: 'Status', value: 'journalstatus', width: '10%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '12%' },
      ],
      data_journals: [],
      data_selected: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('InvestJournal', ['investjournals', 'isReceiving', 'isDeleting', 'idToDelete', 'paymentsMessage', 'isUpdating']),
    ...mapState('InvestFund', ['funds']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('InvestJournal', ["getInvestJournalsRequest", "findInvestJournalsRequest", "deleteInvestJournalRequest","updateInvestJournalRequest","createInvestJournalRequest"]),
    ...mapActions('InvestFund', ["getInvestFundsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getJson(){
      let json = this.data_journals.map(payment=>{return {
        journalnum: payment.journalnum, 
        journaldate: payment.journaldate!=undefined ? new Date(payment.journaldate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        journaltype: payment.journaltype,
        fund: payment.fundid!=undefined && this.funds.length>0 ? this.funds.find(fund=>fund._id == payment.fundid)['fundname'] : '',
        total: payment.journaltotal,
      }});
      return json;
    },
    checkError(){
      if(this.data_selected.length==0) return false;
      if(this.data_selected.find(item=>item.journalstatus=='Completed')!=null) return false;
      return true;
    },
    getFileName(){
      var d = new Date();
      var name = 'payments-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    editItem(item) {
      this.$router.push({ name: 'InvestJournalEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'InvestJournalPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'InvestJournalView', params: item });
    },
    async findInvestJournals(){
      this.isFindJournal = false;
      if(Object.keys(this.find_query).length==0){
        await this.getInvestJournalsRequest();
        this.data_journals = Object.assign([], this.payments);
      }
      else{
        console.log('query')
        console.log(this.find_query)
        let result = await this.findInvestJournalsRequest(this.find_query);
        this.data_journals = Object.assign([], result);
      }
    },
    async resetInvestJournals(){
      this.find_query = {};

    },
    async deleteItem(item) {
      await this.deleteInvestJournalRequest({_id: item._id});
      this.data_journals = this.payments;
      this.isDeleteJournal = false;
    },
    deleteDialog(item) {
      this.isDeleteJournal = true;
      this.delete_journal = {
        _id: item._id, journalnum: item.journalnum }
    },
  },
  async created () {
    if(this.investjournals.length==0) await this.getInvestJournalsRequest();
    this.data_journals = Object.assign([], this.investjournals);

    if(this.funds.length==0) await this.getInvestFundsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
